import styled from 'styled-components/macro';
import media from '../../styles/media';
import { fontSize } from '../../styles/mixins';

export const StyledQuestion = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${fontSize(14)};
  font-weight: 400;
  i {
    ${fontSize(18)};
    margin-right: 8px;
    ${media.desktop({
      marginRight: '4px',
    })}
  }
  ${media.desktop({
    justifyContent: 'flex-start',
  })}
  ${({ marginBottom }) => marginBottom && 'margin-bottom: 20px'}
  ${({ marginRight }) => marginRight && 'margin-right: auto'}
`;
